import { render } from "./FishingCharacter.vue?vue&type=template&id=56d7ccce&scoped=true"
import script from "./FishingCharacter.vue?vue&type=script&lang=js"
export * from "./FishingCharacter.vue?vue&type=script&lang=js"

import "./FishingCharacter.vue?vue&type=style&index=0&id=56d7ccce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d7ccce"]])

export default __exports__